import { emptyArr } from 'util/arrays'
import { createBasicSelector } from 'util/redux'
import { selectCurrentEntities } from 'ducks/entities/selectors'

export const selectConversationLinkedResources = createBasicSelector(
  state =>
    selectCurrentEntities(state, 'conversationLinkedResource') || emptyArr
)
